module.exports = __webpack_public_path__ + "img/agency.fb30511b.svg";